<template>
  <section class="views">
    <headers select="5"></headers>
    <div class="posters">
      <van-image
        width="100%"
        :src="require('@/assets/image/hodgepodge/h5banner_2026.jpg')"
      />
    </div>

    <div class="event-review">
      <div class="event-container">
        <h1 class="review-title">{{ content.title }}</h1>
        <h2 v-if="content.subtitle" class="review-title subtitle">
          {{ content.subtitle }}
        </h2>

        <div class="video-card">
          <div class="video-shell">
            <video
              class="review-video"
              :src="content.videoUrl"
              controls
              preload="metadata"
              playsinline
              webkit-playsinline="true"
              x5-playsinline="true"
              controlslist="nodownload"
            ></video>
          </div>
        </div>

        <div class="review-content">
          <template v-for="(block, index) in content.blocks">
            <p
              v-if="block.type === 'paragraph'"
              :key="`paragraph-${index}`"
              class="text-paragraph"
            >
              {{ block.text }}
            </p>

            <p
              v-else-if="block.type === 'line'"
              :key="`line-${index}`"
              class="text-line"
            >
              {{ block.text }}
            </p>

            <div
              v-else-if="block.type === 'section'"
              :key="`section-${index}`"
              :class="['section-title', block.compact ? 'compact-section' : '']"
            >
              <h2>{{ block.title }}</h2>
            </div>

            <div
              v-else-if="block.type === 'image'"
              :key="`image-${index}`"
              class="image-container"
            >
              <img class="review-image" :src="block.src" :alt="block.alt" />
              <p v-if="block.caption" class="image-caption">{{ block.caption }}</p>
            </div>

            <div
              v-else-if="block.type === 'awards'"
              :key="`awards-${index}`"
              class="award-list"
            >
              <div v-for="(group, awardIndex) in content.awardGroups" :key="awardIndex" class="award-group">
                <div class="award-group-title">{{ group.group }}</div>
                <p v-for="(award, groupIndex) in group.awards" :key="groupIndex" class="award-line">
                  {{ award }}
                </p>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import headers from '@/components/header/h_header';
import review2026Content from '../content';

export default {
  name: 'eventReview2026H5',
  components: {
    headers,
  },
  data() {
    return {
      content: review2026Content,
    };
  },
};
</script>

<style lang="scss" scoped>
.views {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  background: linear-gradient(225deg, #ff8310 0%, #fe840f 100%);
}

.posters {
  width: 100%;
  display: flex;
  position: relative;

  img {
    width: 100%;
  }
}

.event-review {
  width: 100%;
  padding: 0 0 15px 0;

  .event-container {
    width: 92%;
    margin: 0 auto;
    padding: 15px;
    background-color: #fff;
    border-radius: 0 0 8px 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .review-title {
    font-size: 20px;
    color: #d34a00;
    text-align: center;
    margin-bottom: 20px;
    font-weight: bold;
    line-height: 1.4;
  }

  .subtitle {
    margin-top: -8px;
  }

  .video-card {
    width: 100%;
    margin: 0 auto 0.34rem;
    padding: 0.12rem;
    border-radius: 0.24rem;
    background: linear-gradient(
      180deg,
      rgba(255, 236, 221, 0.96) 0%,
      rgba(255, 248, 242, 0.98) 100%
    );
    box-shadow: 0 0.16rem 0.42rem rgba(211, 74, 0, 0.16);
    border: 0.01rem solid rgba(211, 74, 0, 0.12);
    box-sizing: border-box;
  }

  .video-shell {
    border-radius: 0.18rem;
    overflow: hidden;
    background: #120d0a;
    box-shadow: inset 0 0 0 0.01rem rgba(255, 255, 255, 0.14);
  }

  .review-video {
    display: block;
    width: 100%;
    aspect-ratio: 16 / 9;
    background: #120d0a;
  }

  .section-title {
    margin: 25px auto;
    width: 85%;
    padding: 10px;
    border: 2px solid #d34a00;
    border-radius: 8px;
    background: linear-gradient(to right, rgba(255, 120, 47, 0.1), rgba(255, 120, 47, 0.05));
    position: relative;
    text-align: center;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

    &::before,
    &::after {
      content: '';
      position: absolute;
      width: 15px;
      height: 15px;
      border-style: solid;
      border-color: #d34a00;
    }

    &::before {
      top: -5px;
      left: -5px;
      border-width: 3px 0 0 3px;
      border-radius: 5px 0 0 0;
    }

    &::after {
      bottom: -5px;
      right: -5px;
      border-width: 0 3px 3px 0;
      border-radius: 0 0 5px 0;
    }

    h2 {
      margin: 0;
      color: #d34a00;
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 1px;
    }
  }

  .compact-section {
    width: 64%;
    padding: 0.12rem 0.18rem;

    h2 {
      font-size: 0.34rem;
      letter-spacing: 0.02rem;
    }
  }

  .review-content {
    .text-paragraph {
      font-size: 14px;
      line-height: 1.7;
      color: #333;
      margin-bottom: 15px;
      text-indent: 2em;
      text-align: justify;
    }

    .text-line {
      font-size: 14px;
      line-height: 1.7;
      color: #333;
      margin-bottom: 10px;
      text-align: left;
    }

    .image-container {
      margin: 20px 0;
      text-align: center;

      .review-image {
        width: 100%;
        border-radius: 8px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
      }

      .image-caption {
        font-size: 12px;
        color: #666;
        margin-top: 8px;
        font-style: italic;
      }
    }

  }

  .award-list {
    display: grid;
    grid-template-columns: 1fr;
    gap: 14px;
    margin-top: 20px;
  }

  .award-group {
    padding: 16px;
    border-radius: 12px;
    background: linear-gradient(180deg, rgba(255, 120, 47, 0.08), rgba(255, 120, 47, 0.02));
    border: 1px solid rgba(211, 74, 0, 0.12);
    box-shadow: 0 6px 18px rgba(211, 74, 0, 0.08);
  }

  .award-group-title {
    font-size: 16px;
    font-weight: 700;
    color: #d34a00;
    margin-bottom: 8px;
    line-height: 1.5;
  }

  .award-line {
    margin: 0 0 6px;
    font-size: 13px;
    line-height: 1.75;
    color: #333;
    text-align: left;
  }
}
</style>
